import { useLazyQuery } from '@apollo/client/react'
import type { UseListProps, UseListResult } from './index'
import type { LazyQueryExecFunction } from '@apollo/client/react/types/types'
import { useBuildListQueryOptions } from './useBuildListQueryOptions'
import { useBuildListQueryResults } from './useBuildListQueryResults'

export type LazyExecution<T> = { executeQuery: LazyQueryExecFunction<T, any> }
export type UseLazyListResult<T = any> = UseListResult<T> & LazyExecution<T>

export const useLazyList = <T = any>({
  query,
  entity,
  projection,
  sort,
  limit,
  skip,
  filter,
  options = {},
  listActionOptions = {},
}: UseListProps<T>): UseLazyListResult<T> => {
  //prepare for the query options here
  const { queryOptions, listActionResults, dbOptions } = useBuildListQueryOptions({
    query,
    entity,
    projection,
    sort,
    limit,
    skip,
    filter,
    options,
    listActionOptions,
  })

  //execute the query here
  const [executeQuery, queryResult] = useLazyQuery(query, queryOptions)

  //parse the result
  const lazyQueryResult = useBuildListQueryResults<T>({
    queryResult,
    entity,
    limit,
    dbOptions,
    listActionResults,
  })

  return {
    ...lazyQueryResult,
    executeQuery,
  }
}
